import React, { Component, PropTypes } from 'react'
import { paths } from '../routes'
//import { connect } from 'react-redux'
//import { createSelector } from 'reselect'
import Select from 'react-select'
import { addBodyClass, removeBodyClass, toggleBodyClass } from '../helpers.js'
//import moment from 'moment'
import classNames from 'classnames'
//import Loader from '../components/Loader'
//import { Link } from 'react-router'
import Swipeable from 'react-swipeable'
import Header from '../components/Header'
import Sidebard from '../components/Sidebard'
import NotificationSystem from 'react-notification-system'
import { base, firebaseApp } from '../../config'
import Onboarding from '../components/Onboarding'
import { browserHistory } from 'react-router'

export class App extends Component {
    // static contextTypes = {
    //     router: React.PropTypes.object.isRequired
    // }

    constructor(props) {
        super(props)
        this.state = {
          direction: false,
          lastScrollPos: 0,
          loading: true,
          user: null
        };
        this._notificationSystem = null
        this.onSwipingDown = this.onSwipingDown.bind(this)
        this.onSwipingUp = this.onSwipingUp.bind(this)
        this._authenticate = this._authenticate.bind(this)

    }

    componentDidMount() {
      this._authenticate()
      window.addEventListener("touchmove", this.handleScroll, false)
      addBodyClass(this.props.location.pathname.replace("/", '') + "-in-view")




    }

    componentWillUnmount() {
      window.removeEventListener("touchmove", this.handleScroll, false)
    }

    _authenticate() {
      firebaseApp.auth().onAuthStateChanged((user) => {
        if (user) {
          if (this.props.location.pathname === '/' || this.props.location.pathname === 'login' || this.props.location.pathname === 'register') browserHistory.push('/jobs')
          this.setState({user})
          base.syncState(`user_details/${user.uid}/details`, {
              context: this,
              state: 'details',
              keepKeys: false,
              then () {
                //_this.props.setJob(this.state.mainJob)

              }
          })
        } else {
          browserHistory.push('/')
          this.setState({user: null})
        }
      })
    }

    componentWillReceiveProps(nextProps) {
      console.log(this)
        if (nextProps.location.pathname != this.props.location.pathname) {
          $(window).scrollTop(0)
          this.setState({direction:false})
          // removeBodyClass(this.props.location.pathname.replace("/", '') + "-in-view")
          // addBodyClass(nextProps.location.pathname.replace("/", '') + "-in-view")
        }
    }

    _addNotification (message, time, level) {
      this._notificationSystem.addNotification({
          message: message,
          level: level,
          autoDismiss: time,
          position: 'tc'
      })
    }

    onSwipingUp(e, deltaX, deltaY, absX, absY, velocity) {this.setState({direction:true})}

    onSwipingDown(e, absX) {this.setState({direction:false})}

    _onboardingStepper(step) {
        alert("Asdfasdf");
    }

    _tour() {
        this.setState({
            tour: !this.state.tour
        })
    }

    render() {

        let classes = classNames({
            'main': true,
            'hide-mobile-els': this.state.direction,
        })

        return (
            <div className={classes}>

                <NotificationSystem ref={n => this._notificationSystem = n} />

                <Onboarding
                    step={1}
                    stepper={this._onboardingStepper.bind(this)}
                    tour={this._tour.bind(this)}
                />

                { !this.state.user &&
                   <main className="main">
                       { React.cloneElement(this.props.children, {notify: this._addNotification.bind(this)})}
                   </main>
                }

                { this.state.user && this.state.user.uid &&
                    <span>
                        <Header
                            authenticated={this.state.user.uid }
                            signOut={this.props.signOut}
                            user={this.state.user}
                            params={this.props.params}
                            location={this.props.location}
                        />
                        { this.state.user.uid &&
                          <main className={classes}>
                            <Swipeable
                              onSwipingDown={this.onSwipingDown}
                              onSwipingUp={this.onSwipingUp}>
                              { React.cloneElement(this.props.children, {
                                  base: base,
                                  user: this.state.user,
                                  uid: this.state.user.uid,
                                  details: this.state.details,
                                  email: this.state.user.email,
                                  notify: this._addNotification.bind(this),
                                })
                              }
                            </Swipeable>
                            <Sidebard location={this.props.location} />
                          </main>
                        }
                    </span>
                }
            </div>
        )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/views/app/index.js